<template>
	<div class="hello">
		<myHeader></myHeader>
		<!-- 地图容器 -->
		<div id="map"></div>
		<!-- 地图上的类型选择按钮 -->
		<div class="typeBtn" @click="drawFun">
			<el-icon :size="30">
				<Location />
			</el-icon>
			<span>类型</span>
		</div>

		<div class="typeBtn introBtn" @click="showIntro" v-if="introFlag">
			<el-icon :size="30">
				<Document />
			</el-icon>
			<span>介绍</span>
		</div>
		<!-- 抽屉 -->
		<el-drawer :size="150" title="类型选择" v-model="drawer">
			<div class="menuBox" v-for="item in getMenuData.data" :key="item.menuId"
				@click="getMark(item.menuIcon,item.menuId)">
				<img :src="defaultUrl+item.menuIcon" alt="ll">
				<span>{{item.menuName}}</span>
			</div>
		</el-drawer>
		<!-- tab标签页 -->
		<div class="tabs" v-if="tabFlag">
			<el-tabs v-model="editableTabsValue" class="demo-tabs" tab-position="top" @tab-click="handleClick" stretch>
				<el-tab-pane v-for="item in editableTabs.data" :key="item.label"
					:name="item.value ? item.value :item.hotIndustryId">
					<!-- {{ item.content }} -->
					<template #label>
						<span class="custom-tabs-label">
							<el-icon :size="18"><WalletFilled /></el-icon>
							<span>{{ item.label ? item.label :item.hotIndustryName }}</span>
						</span>
					</template>
				</el-tab-pane>
			</el-tabs>
		</div>
		<!-- 弹框 -->
		<popupRender :detail="detail.data" :title="propsTitles" @closePop="closePop" v-if="popFlag"></popupRender>

		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		onMounted,
		reactive,
		ref,
		nextTick
	} from 'vue';
	import {
		ElMessage
	} from 'element-plus'
	import {
		init
	} from './init';
	import myHeader from '@/components/layouts/myHeader';
	import bottomMenu from '@/components/layouts/bottomMenu'
	import popupRender from './popupRender.vue';
	import {
		getMenuList,
		getMarkList,
		getTypeInfo,
		hotIntro,
		getMarksListByProjectType,
		getDetail
	} from '../axios/api.js';
	import {
		useRouter
	} from 'vue-router' //,useRoute 
	export default {
		name: 'CDMap',
		props: {
			msg: String
		},
		components: {
			myHeader,
			bottomMenu,
			popupRender
		},
		setup() {
			//  数据声明 -----------------------------------------------------------
			let defaultUrl = 'https://ysdtapi.cdssjj.changde.gov.cn/cdMapApi';
			const L_map = reactive({
				map: null,
				L: null
			}); //leaflet 对象实例
			const drawer = ref(false); //抽屉控制
			const editableTabsValue = ref('0') //底部标签控制
			const editableTabs = reactive({
				data: []
			}); //标签数据
			const getMenuData = reactive({
				data: []
			}); //菜单列表数据
			const markRemove = reactive({
				data: []
			}); //记录需要移除的标点
			const tabFlag = ref(false);
			const introFlag = ref(false);
			//  通过对应的菜单id去匹配url
			const id_api = reactive({
				data: [{
						id: 2,
						url: '/cdMapApi/api/project/getMarksListByProjectType'
					},
					{
						id: 3,
						url: '/cdMapApi/api/assorts/getList'
					},
					{
						id: 4,
						url: '/cdMapApi/api/businesses/getList'
					},
					{
						id: 5,
						url: '/cdMapApi/api/hotIndustry/getMarksListByTypeId'
					}
				]
			});

			const popFlag = ref(false)
			const detail = reactive({
				data: {}
			}); //详情数据
			const propsTitles = ref(null); //详情标题
			const router = useRouter();
			//路由相关 --------------------------------------------------------------
			function pushWithQuery(name, query, title) {
				router.push({
					name: name,
					query: {
						query,
						title
					},
				})
			}

			// api函数 ------------------------------------------------------------
			//获取菜单列表api
			(function getMenu() {
				getMenuList('/cdMapApi/api/getMenuList', {}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						getMenuData.data = data;
						//在本地sessionStorage 保存一个curMeunId
						if (!sessionStorage['curMeunId'] && !sessionStorage['iconUrl']) {
							sessionStorage.setItem('curMeunId', data[0].menuId);
							sessionStorage.setItem('iconUrl', data[0].menuIcon);
						} else if (!sessionStorage['iconUrl'] && sessionStorage['curMeunId']) {
							for (let i = 0; i < data.length; i++) {
								if (data[i].menuId == sessionStorage['curMeunId']) {
									sessionStorage.setItem('iconUrl', data[i].menuIcon);
								}
							}
						}
						getMark();
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				}).catch(function(error) {
					console.log(error);
				})
			})();
			//商圈介绍api
			function commerIntro() {
				hotIntro('/cdMapApi/api/hotIndustry/getDetail', {
					hotIndustryId: editableTabsValue.value
				}).then(function(res) {
					
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						detail.data = data;
						propsTitles.value = data.hotIndustryName;

					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				}).catch(function(error) {
					console.log(error);
				})
			}
			//标点列表api
			function getMark(itemUrl, menuId) {
				if (arguments.length == 2) {
					sessionStorage['curMeunId'] = menuId;
					sessionStorage['iconUrl'] = itemUrl;
				}
				popFlag.value = false;
				getMarkList('/cdMapApi/api/getMarkListByMenuId', {
					marksMenuId: sessionStorage['curMeunId']
				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						editableTabsValue.value = '0';
						//去掉所有的标记点
						markFor(sessionStorage['iconUrl'], data);
						L_map.map.setView([29.037426, 111.705255], 9);
						// 根据id 显示不同的tab 或者关闭tab
						tabFlag.value = true;
						let url;
						switch (Number(sessionStorage['curMeunId'])) {
							case 2:
								introFlag.value = false;
								url = '/cdMapApi/api/project/getTypeInfo'
								itemType(url);
								break;
							case 3:
								introFlag.value = false;
								url = '/cdMapApi/api/assorts/getTypeInfo'
								itemType(url);
								break;
							case 4:
								introFlag.value = false;
								url = '/cdMapApi/api/businesses/getTypeInfo'
								itemType(url);
								break;
							case 5:
								url = '/cdMapApi/api/hotIndustry/getType'
								itemType(url);
								break;
							default:
								tabFlag.value = false;
								introFlag.value = false;
						}
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				}).catch(function(error) {
					console.log(error);
				})
			}

			//标点的循环函数
			function markFor(itemUrl, data) {
				//去掉所有的标记点
				removeMarker();
				markRemove.data = [];
				for (let i = 0; i < data.length; i++) {
					//调用函数进行标点
					let divMark = divMarker('ripple', [data[i].marksLatitude + 0.00202472, data[i].marksLongitude - 0.0045377577], data[i].marksName)
					let markerObj = marker({
						iconUrl: defaultUrl + itemUrl,
						lat: [
							data[i].marksLatitude + 0.00202472,
							data[i].marksLongitude - 0.0045377577
						],
						marksId: data[i].marksId,
						titles: data[i].marksName
					});
					markRemove.data.push(markerObj, divMark);
				}
			}

			//项目，配套，招商产业类型
			function itemType(url) {
				//id_api
				getTypeInfo(url, {}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						editableTabs.data = data;
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				}).catch(function(error) {
					console.log(error);
				})
			}
			// 找项目 ---项目类型标点 --比如 电子信息
			function handleClick(tab) {
				let {
					name
				} = tab.props;
				let url;
				for (let i = 0; i < id_api.data.length; i++) {
					if (sessionStorage['curMeunId'] == id_api.data[i].id) {
						url = id_api.data[i].url;
					}
				}
				// 项目
				getMarksListByProjectType(url, {
					typeId: name
				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						markFor(sessionStorage['iconUrl'], data)
						if (Number(sessionStorage['curMeunId']) == 5) {
							introFlag.value = true;
							commerIntro()
						} else {
							introFlag.value = false;
						}
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				}).catch(function(error) {
					console.log(error);
				})
			}
			
			//弹出框详情页面
			function detailFun(marksId) {
				// getDetail
				let url;
				switch (Number(sessionStorage['curMeunId'])) {
					case 3:
						url = '/cdMapApi/api/assorts/getDetail';
						break;
					case 4:
						url = '/cdMapApi/api/businesses/getDetail';
						break;
					case 6:
						url = '/cdMapApi/api/traffics/getDetail';
						break;
					case 7:
						url = '/cdMapApi/api/servicePoint/getDetail';
						break;
					case 8:
						url = '/cdMapApi/api/organs/getDetail';
						break;
					default:
						return
				}
				getDetail(url, {
					marksId
				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						detail.data = data;
						popFlag.value = true;
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				}).catch(function(error) {
					console.log(error);
				})
			}
			//配套类型
			//地图操作相关函数-------------------------------------------------------------------
			//图片位置标记函数
			function marker({
				iconUrl,
				lat,
				marksId,
				titles
			}) {
				const myIcon = L_map.L.icon({
					iconUrl: iconUrl,
					title: marksId,
					name: titles,
					iconSize: [40, 40], // size of the icon
				});
				let layMarker = L_map.L.marker(lat, {
					icon: myIcon
				}).addTo(L_map.map);
				layMarker.on('click', function(e) {
					let marksId = e.target.options.icon.options.title;
					propsTitles.value = e.target.options.icon.options.name;
					if (sessionStorage['curMeunId'] == 1) {
						pushWithQuery('parkIntro', marksId, titles);
					} else if (sessionStorage['curMeunId'] == 2) {
						pushWithQuery('projectSel', marksId);
						if(propsTitles.value == '武陵区') {
							sessionStorage['area'] = 1
						} else if (propsTitles.value == '鼎城区') {
							sessionStorage['area'] = 2
						} else if (propsTitles.value == '汉寿县') {
							sessionStorage['area'] = 3
						} else if (propsTitles.value == '桃源县') {
							sessionStorage['area'] = 4
						} else if (propsTitles.value == '澧县') {
							sessionStorage['area'] = 5
						} else if (propsTitles.value == '临澧县') {
							sessionStorage['area'] = 6
						} else if (propsTitles.value == '石门县') {
							sessionStorage['area'] = 7
						} else if (propsTitles.value == '安乡县') {
							sessionStorage['area'] = 8
						} else if (propsTitles.value == '津市市') {
							sessionStorage['area'] = 9
						} else if (propsTitles.value == '经开区') {
							sessionStorage['area'] = 10
						} else if (propsTitles.value == '高新区') {
							sessionStorage['area'] = 11
						} else if (propsTitles.value == '柳叶湖旅游渡假区') {
							sessionStorage['area'] = 12
						} else if (propsTitles.value == '西湖管理区') {
							sessionStorage['area'] = 13
						} else if (propsTitles.value == '西洞庭管理区') {
							sessionStorage['area'] = 14
						} else if (propsTitles.value == '桃花源风景名胜区') {
							sessionStorage['area'] = 15
						} else {
							sessionStorage['area'] = 0
						}
						sessionStorage['type'] = editableTabsValue.value;
					} else if (sessionStorage['curMeunId'] == 9) {
						pushWithQuery('massifsDetail', marksId, titles);
					} else {
						detailFun(marksId);
					}

				})
				return layMarker;
			}
			//移除位置标记函数
			function removeMarker() {
				for (let i = 0; i < markRemove.data.length; i++) {
					markRemove.data[i].remove();
				}
			}
			//div 位置标记
			function divMarker(className, lat, markerName) {
				const myIcon = L_map.L.divIcon({
					className: className,
					html: '<div style="font-size:14px; font-weight:bold; display:inline; background:#fff; padding:6px; border:1px solid #00aaff; border-radius:5px;">' +
						markerName + '</div>',
					iconAnchor: [50, 45], // point of the icon which will correspond to marker's location
					iconSize: [260, 15]
				}); //
				// 你可以在 .my-div-icon CSS 中设置样式
				let layer = L_map.L.marker(lat, {
					icon: myIcon
				}).addTo(L_map.map);
				return layer;
			}
			//控制DOM节点显示与关闭相关函数 --------------------------------------------------------------------
			//抽屉显示与关闭
			function drawFun() {
				drawer.value = !drawer.value;
			}

			function closePop() {
				popFlag.value = false;
			}

			function showIntro() {
				popFlag.value = true;
			}
			
			//钩子函数  --------------------------------------------------------------------------
			onMounted(() => {
				const {
					map,
					L
				} = init();
				L_map.map = map;
				L_map.L = L;
				nextTick(() => {

				})
			})

			return {
				marker,
				drawer,
				drawFun,
				divMarker,
				editableTabs,
				editableTabsValue,
				defaultUrl,
				getMenuData,
				getMark,
				tabFlag,
				handleClick,
				detail,
				popFlag,
				propsTitles,
				closePop,
				showIntro,
				introFlag
			}
		},

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.hello {
		height: 100%;
		position: relative;
	}

	#map {
		height: calc(100% - 70px);
	}

	.typeBtn {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: absolute;
		right: 8%;
		top: 15%;
		width: 50px;
		z-index: 999;
		background: #fff;
		padding: 2px 0;
		border-radius: 5px;
	}

	.introBtn {
		top: 25%;
	}
	.el-drawer__title {
		color: #333;
		font-size: 18px!important;
		font-weight: bold;
	}
	.el-drawer__body {
		padding: 20px 10px!important;
	}

	.menuBox {
		display: flex;
		align-items: center;
		padding: 15px 0px 5px;
	}

	.menuBox span {
		height: 25px;
		color: #636363;
		font-size: 16px;
		font-weight: 800;
		padding-left: 2px;

	}

	.menuBox img {
		width: 25px;
		height: 25px;
	}

	.tabs {
		position: absolute;
		bottom: 70px;
		width: 100%;
		z-index: 999;
		background: #fff;
	}

	.el-tabs {
		padding: 0 10px;
	}
	.el-tabs__nav-prev, .el-tabs__nav-next {
		color: #333;
	}
	.el-tabs__item {
		color: #666;
		padding: 0px 10px!important;
	}
	.custom-tabs-label {
		display: flex;
		align-items: center;
	}
	
	.custom-tabs-label span {
		padding-left: 0px;
	}
</style>